import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "Yannick Sluyts",
  title: "PhD Student at KU Leuven",
  description: `Yannick Sluyts was born in 1993. After first obtaining a visual arts degree he turned to architecture. During his Master, he was first involved with assisting in acoustic experiments as well as with the preparation of content for a free online education platform (acoucou - ACI). He is currently doing his Ph.D. in architectural acoustics at the Faculty of Architecture of KULeuven, Belgium. The project is focused on the room acoustic properties of ETFE (cladding material) and is under the supervision of Prof. Dr. Monika Rychtarikova. He works in the Laboratory of Acoustics of KULeuven on a daily basis and partly assists in teaching architecture bachelor and master students about architectural acoustics and room acoustic simulation.
  `,
  imageUrl: appConfig.ASSETS_URL + "/02/authors/yannick-sluyts.jpg",
};

export default author;
